export const campaignsKeys = {
  all: ['campaigns'] as const,
  lists: () => [...campaignsKeys.all, 'list'] as const,
  list: (params?: Record<string, any>) =>
    [...campaignsKeys.lists(), params] as const,

  details: () => [...campaignsKeys.all, 'detail'] as const,
  detail: (id: number) => [...campaignsKeys.details(), id] as const,
};
